const generator = require('./purchase-fullcont-multitable-generator')
const timeDate  = require ('../../../../../../js-handler/time-date')

export function start(detail){ 
         
      obj[detail.act].start(detail)
}/**/

const obj = {
   
      add: { start: (detail)=>{ add(detail) }},
}

//add line
function add(detail){ 
	purchaseMT.forEach((mt)=>{
		//console.log(mt)
		if(mt.tableName === detail.tableName){
			//se agrego propiedad de tab para validar si se esta creando el la linea por medio del boton tab
			//si es asi pues solo has un focus
			if (detail.tab == undefined) {
				mt.add()
			}else{
				mt.add(detail.tab)
			}
		}/*if*/
	}) 
}

export const purchaseMT = [

	{
		tableName: "purchase_vs_item", 
		value:'', 
		id:'purchase_form_purchase_vs_item2',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{ name:      'item_id', 
			  type:      'autocomplete',
			  html:      '',
			  required:  true,  },

			{ name:      'type_selling', 
			  type:      'autocomplete',
			  html:      '',
			  required:  true,  },

			{ name:      'qty', 
			  type:      'textfield',
			  html:      '',
			  required:  false,  },

			{ name:      'unit_price', 
			  type:      'textfield',
			  html:      '',
			  required:  false,  },

			{ name:      'selling_price', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },

			{ name:      'total_price', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },

			{ name:      'cogs_row_amount', 
			  type:      'textfield',
			  html:      '',
			  required:  false,  },

		],

		generator: function(line){ 
			return generator.purchase_vs_item(line.id) 
		},

		add: function(tab = false){ 
			const newLine = generator.purchase_vs_item('')
			this.html.insertAdjacentHTML("beforeend", newLine) 

			const allLines    = this.html.querySelectorAll('.item_id')
			const lastLine    = allLines[allLines.length - 1]
			const targetInput = lastLine.querySelector('input')

			targetInput.focus()
			if (!tab) {
				targetInput.click()
			}

		} 
	},

	{
		tableName: "purchase_vs_investment", 
		value:'', 
		id:'purchase_form_purchase_vs_investment2',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{ name:      'investorId', 
			  type:      'autocomplete',
			  html:      '',
			  required:  false,  },

			{ name:      'invested_amount', 
			  type:      'textfield',
			  html:      '',
			  required:  false,  },

			{ name:      'revenue', 
			  type:      'textfield',
			  html:      '',
			  required:  false,  },

			{ name:      'revenue_amount', 
			  type:      'textfield',
			  html:      '',
			  required:  false,  },

			{ name:      'status', 
			  type:      'multiselect',
			  html:      '',
			  options :  ["requested", "waiting on deposit", "approved", "rejected", "paid to Investor"],
			  required:  false,  },
		],

		generator: function(line){ 
			return generator.purchase_vs_investment(line.id) 
		},

		add: function(){ 
			const newLine = generator.purchase_vs_investment('')
			this.html.insertAdjacentHTML("beforeend", newLine) 
		} 
	},

	{
		tableName: "purchase_vs_expenses", 
		value:'', 
		id:'purchase_form_purchase_vs_expenses2',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{ name:      'provider_id', 
			  type:      'autocomplete',
			  html:      '',
			  required:  true,  },

			{ name:      'expenses_account_id', 
			  type:      'autocomplete',
			  html:      '',
			  required:  true,  },

			{ name:      'date', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },

			{ name:      'amount', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },
		],

		generator: function(line){ 
			return generator.purchase_vs_expenses(line.id) 
		},

		add: function(){ 
			const newLine = generator.purchase_vs_expenses('')
			this.html.insertAdjacentHTML("beforeend", newLine) 

			const allLines    = this.html.querySelectorAll('.provider_id')
			const lastLine    = allLines[allLines.length - 1]
			const targetInput = lastLine.querySelector('input')
			targetInput.focus()
			targetInput.click()
		} 
	},

	{
		tableName: "purchase_tracking_mail", 
		value:'', 
		id:'purchase_form_tracking_mail2',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{ name:      'email', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },

			{ name:      'mail_date', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },

			{ name:      'mail_time', 
			  type:      'textfield',
			  html:      '',
			  required:  true,  },

			{ name:      'providerId', 
			  type:      'autocomplete',
			  html:      '',
			  required:  true,  },

		],

		generator: function(line){ 
			return generator.purchase_tracking(line.id) 
		},

		add: function(){ 
			const newLine = generator.purchase_tracking('')
			this.html.insertAdjacentHTML("beforeend", newLine) 
		} 
	},
	{
		tableName: "purchase_vs_lost", 
		value:'', 
		id:'purchase_form_purchase_vs_lost2',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'purchase_vs_itemId', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},

			{
				name:      'return_item', 
				value:	   'true',
				type:      'checkbox',
				html:      '',
				required:  false,  
			},

			{ 
				name:      'lost_qty', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},

			{
				name:      'lost_price', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
	

			{ 
				name:      "date", 
				value:     '0000-00-00', 
				date:      true,	
				html:	 	 '',
				type:		 'textfield',
				required:  true,  
			}, 


			{ 
				name:      'notes', 
				type:      'textfield',
				html:      '',
				required:  false,  
			},

		],

		generator: function(line){ 
			return generator.purchase_vs_lost(line.id) 
		},

		add: function(){ 
			const newLine = generator.purchase_vs_lost('')
			this.html.insertAdjacentHTML("beforeend", newLine) 
			
			const allLines    = this.html.querySelectorAll('.line')
			const lastLine    = allLines[allLines.length - 1]

			const input_item  = lastLine.querySelector('.purchase_vs_itemId') 
			const targetInput = input_item.querySelector('input')
			targetInput.focus()
			targetInput.click()

			const input_date  = lastLine.querySelector('.date input');
			input_date.value  = timeDate.convertDateToInput();

		} 
	}

]
